// material-ui
import { Grid, Typography, Stack, Link } from '@mui/material';

// project imports
import MainCard from 'components/cards/MainCard';
import Main from 'views/layouts/Main/Main'; //
import {
	SimUnorderedList,
	SimSection,
	SimSectionHeader,
	StaticSectionWrapper
} from 'components/StaticSections';

const NonDiscriminationCompliance = () => {
	return (
		<Main>
			<StaticSectionWrapper>
				<Grid container justifyContent='center' spacing={1}>
					<SimSectionHeader title='NON-DISCRIMINATION COMPLIANCE' />
					<Grid item xs={12}>
						<MainCard elevation={4} border={false} boxShadow shadow={4} sx={{ mb: 3 }}>
							<Stack spacing={2} sx={{ textAlign: 'left' }}>
								<Typography textAlign={'justify'}>
									SIM SOULS GROUP LLC and SIM SOULS INSTITUTE 1 INC complies with applicable federal
									civil rights laws and does not discriminate on the basis of religion, race, color,
									national origin, age, disability, or sex. Sim Souls Institute 1 LLC does not exclude
									people or treat them differently because of religion race, color, national origin,
									age, disability, or sex.
								</Typography>

								<SimSection title='SIM SOULS GROUP LLC and SIM SOULS INSTITUTE 1 INC:'>
									<SimUnorderedList
										list={[
											'Provides free aid and services to people with disabilities to communicate effectively with us.',
											'Provides free language services to people whose primary language is not English.'
										]}
									/>
								</SimSection>
								<Typography textAlign={'justify'}>
									If you believe that SIM SOULS GROUP LLC and SIM SOULS INSTITUTE 1 INC has failed to
									provide these services or discriminated in another way on the basis of religion,
									race, color, national origin, age, disability, or sex, you can file a grievance by
									calling us @ +1.469.269.0515 or emailing us at{' '}
									<Link href='#' underline='none'>
										compliance@simsouls.com
									</Link>
								</Typography>

								<Typography textAlign='justify'>
									You can also file a civil rights complaint with the Texas WorkForce Civil Rights
									Commission filing electronically at
									https://www.twc.texas.gov/partners/civil-rights-discrimination or by calling
									+1.888.452.4778 if you are within Texas or by calling +1.512.463.2642 if you are
									out-of-state.
								</Typography>

								<Typography textAlign='justify'>
									You can file a civil rights complaint with the U.S. Department of Health and Human
									Services, Office for Civil Rights electronically through the Office for Civil Rights
									Complaint Portal, available at https://ocrportal.hhs.gov/ocr/portal/lobby.jsf, or by
									mail or telephone at:
								</Typography>
								<Typography textAlign='justify'>
									<strong>U.S. Department of Health and Human Services</strong> <br />
									200 Independence Avenue, SW <br />
									Room 509F, HHH Building <br />
									Washington, D.C. 20201 <br />
									1-800-368-1019; 1-800-537-7697 (TDD)
								</Typography>
							</Stack>
						</MainCard>
					</Grid>
				</Grid>
			</StaticSectionWrapper>
		</Main>
	);
};

export default NonDiscriminationCompliance;
